const idToKeyCamelCase = str => {
  return str
    .toLowerCase()
    .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    })
    .replace(/\s|-+/g, '');
};

function strToUrl(str) {
  return str
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9- ]/g, '')
    .replace(/\s+/g, '-');
}

function strFirstCaseUpper(str) {
  return str.toLowerCase().replace(/^./, str[0].toUpperCase());
}

const hyphensToSpaces = str => str.replace(/-/g, ' ');

const arrayContains = (arr, stringToSearch) => {
  return new RegExp(stringToSearch).test(
    typeof arr === 'string' ? arr : arr.join()
  );
};

const capitalizeFirstLetter = str => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

const formatPhoneNumber = phoneNumber => {
  let num =
    typeof phoneNumber === 'string' ? phoneNumber : phoneNumber.toString();
  num = num.replace('+', '');

  return /^56/.test(num)
    ? num.replace(/(\d{2})(\d)(\d{4})(\d{4})/, '+$1 $2 $3 $4')
    : num.replace(/(\d)(\d{4})(\d{4})/, '+56 $1 $2 $3');
};

const formatHeaderPhoneNumber = phoneNumber => {
  let num =
    typeof phoneNumber === 'string' ? phoneNumber : phoneNumber.toString();
  num = num.replace('+', '');

  return /^56/.test(num)
    ? num.replace(/(\d{2})(\d{1})(\d{4})(\d{4})/, '+$1$2 $3 $4')
    : num.replace(/(\d)(\d{4})(\d{4})/, '+56 $1 $2 $3');
};

/**
 * Helper that remove "y " string of a text and put first chart to upper case.
 * @param {string} text
 * @returns Text without y in string.
 * EX: deleteYInText('fecha y hora') -> 'fecha hora'
 */
const formatTextWithoutY = text => {
  return text.replace('y ', '').replace(/^\w/, c => c.toUpperCase());
};

const formatRutWithoutHyphen = rut => {
  return rut.includes('-') ? rut : `${rut.slice(0, -1)}-${rut.slice(-1)}`;
};

export default {
  idToKeyCamelCase,
  hyphensToSpaces,
  strFirstCaseUpper,
  arrayContains,
  strToUrl,
  formatPhoneNumber,
  formatTextWithoutY,
  capitalizeFirstLetter,
  formatHeaderPhoneNumber,
  formatRutWithoutHyphen,
};
